function isEqual(valueA, valueB) {
  return (
    valueA?.unit === valueB?.unit &&
    valueA?.value === valueB?.value &&
    valueA?.original_value === valueB?.original_value
  );
}

export default isEqual;
